import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Col,
    Row
} from 'reactstrap';

import {fetchApplicationPDF} from "../../actions/application";

import ApplicationDisplay from "../../../../components/application/ApplicationDisplay";
import SummaryModule from "../SummaryModule";

class SummaryFrame extends Component {
    render() {

        const {application, _fetchApplicationPDF} = this.props;

        return (
            <div style={{marginBottom: '3em'}}>
                <Row>
                    <Col md={8} className="col-mobile-left">
                        <h3>Your application</h3>
                    </Col>
                    <Col md={4} className="col-mobile-right">
                        <Button className="float-right" color="primary" disabled={application.application_percent_complete !== 100} onClick={_fetchApplicationPDF}>Download Application</Button>
                    </Col>
                </Row>
                <hr/>
                <SummaryModule/>
                <ApplicationDisplay application={application}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    application: state.tenant.application
});

const mapDispatchToProps = (dispatch, props) => ({
    _fetchApplicationPDF() {
        return dispatch(fetchApplicationPDF());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryFrame);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/Summary.js